import React, {useState} from "react";
import {Box, Button, Stack, Typography} from "@mui/material";
import {IconPlus} from "@tabler/icons-react";
import {CreateVariableModal} from "../settings/CreateVariableModal";
import {VarAssignmentCard} from "../vars/VarAssignmentCard";
import {SectionHeader} from "./EditMenuSection";
import {UI, rgba} from "../../uiTokens";

/**
 * Header + add button + list of variable-assignment cards, backed by
 * `node.data[dataKey]`. Shared by the Input Params and Output Params tabs.
 */
export const ParamAssignmentsPanel = ({node, onUpdate, project, dataKey, title, description}) => {
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(null);
    const params = node?.data?.[dataKey] || [];

    const openEditor = (param = null) => {
        setSelected(param);
        setOpen(true);
    };

    return (
        <>
            <CreateVariableModal
                open={open}
                handleClose={() => {
                    setOpen(false);
                    setSelected(null);
                }}
                project={project}
                editParam={selected}
                isForm={!!node?.data?.form_id}
                onUpdateParams={(newParams) => onUpdate({...node, data: {...node.data, [dataKey]: newParams || []}})}
                params={params}
            />

            <Box>
                <Stack direction="row" alignItems="center" gap={1}>
                    <Box sx={{flex: 1}}>
                        <SectionHeader title={title} description={description}/>
                    </Box>
                    <Button
                        size="small"
                        startIcon={<IconPlus size={15}/>}
                        onClick={() => openEditor(null)}
                        sx={{
                            flexShrink: 0,
                            textTransform: "none",
                            fontWeight: 600,
                            borderRadius: "8px",
                            color: UI.accent,
                            "&:hover": {backgroundColor: rgba(UI.accent, 0.1)},
                        }}
                    >
                        Add
                    </Button>
                </Stack>
            </Box>

            {params.length === 0 ? (
                <Box sx={{p: 2, borderRadius: "10px", border: `1px dashed ${rgba(UI.ink, 0.15)}`, textAlign: "center"}}>
                    <Typography sx={{fontSize: 12, color: UI.muted}}>No params yet.</Typography>
                </Box>
            ) : (
                <Stack gap={1}>
                    {params.map((param, index) => (
                        <VarAssignmentCard
                            key={`${param.uid}-${index}`}
                            param={param}
                            onEdit={() => openEditor(param)}
                        />
                    ))}
                </Stack>
            )}
        </>
    );
};
